module.exports = __webpack_public_path__ + "static/media/recommended3.182d9ab9.png";